// const stickyButtonCheck = () => {
//   if (window.innerWidth > 768) return;
  
//   const stickyButton = document.querySelector("#fixed-select-size-btn");
//   if (!stickyButton) return;

//   const options = { root: null, rootMargin: "0px", threshold: 0 };
//   const handleVisibility = (entries) => {
//     entries.forEach((entry) => {
//       if (entry.isIntersecting) {
//         stickyButton.style.display = "none";
//       } else {
//         stickyButton.style.display = "block";
//       }
//     });
//   };

//   const observer = new IntersectionObserver(handleVisibility, options);

//   // Observe main "Add to Cart" or "Size" button
//   const targetAddToCart = document.querySelector(".buy-buttons .button");
//   if (targetAddToCart) observer.observe(targetAddToCart);

//   // Observe "Notify Me" button (Klaviyo)
//   const targetNotifyMe = document.querySelector(".buy-buttons .shopify-payment-button");
//   if (targetNotifyMe) observer.observe(targetNotifyMe);

//   // Observe footer
//   const observerFooter = new IntersectionObserver(handleVisibility, options);
//   const targetFooter = document.querySelector(".shopify-section-group-footer-group");
//   if (targetFooter) observerFooter.observe(targetFooter);

//   // Sticky button behavior
//   const btnSticky = stickyButton.querySelector(".button");
//   if (btnSticky) {
//     btnSticky.addEventListener("click", () => {
//       if (btnSticky.classList.contains("anchor")) {
//         document.querySelector(".product-detail__form")?.scrollIntoView({ behavior: "smooth" });
//       } else {
//         const notifyMeButton = document.querySelector(".button.alt.backin.klaviyo-bis-trigger");
//         if (notifyMeButton) {
//           notifyMeButton.click();
//         } else {
//           document.querySelector(".buy-buttons .button")?.click();
//         }
//       }
//     });
//   }
// };

// stickyButtonCheck();



// document.addEventListener('DOMContentLoaded', function () {
//   // Product Card Swipers — multiple instances
//   document.querySelectorAll('.product-card-slider').forEach(container => {
//     const slider = container.querySelector('.variant-swiper');
//     const prev = container.querySelector('.swiper-button-prev');
//     const next = container.querySelector('.swiper-button-next');

//     if (slider && prev && next) {
//       const swiper = new Swiper(slider, {
//         slidesPerView: 'auto',
//         spaceBetween: window.innerWidth <= 768 ? 5 : 8,
//         freeMode: true,
//         navigation: {
//           nextEl: next,
//           prevEl: prev,
//         },
//         on: {
//           init: function () {
//             updateNavButtons(this, prev, next);
//           },
//           slideChange: function () {
//             updateNavButtons(this, prev, next);
//           },
//           resize: function () {
//             updateNavButtons(this, prev, next);
//           },
//           reachBeginning: function () {
//             prev.style.display = 'none';
//           },
//           reachEnd: function () {
//             next.style.display = 'none';
//           },
//           fromEdge: function () {
//             updateNavButtons(this, prev, next);
//           }
//         }
//       });
//     }
//   });

//   // Product Page Swiper — single instance
//   document.querySelectorAll('.product-page .variant-swiper').forEach(slider => {
//     const prev = slider.querySelector('.swiper-button-prev');
//     const next = slider.querySelector('.swiper-button-next');

//     if (slider && prev && next) {
//       const swiper = new Swiper(slider, {
//         slidesPerView: 'auto',
//         spaceBetween: 8,
//         freeMode: true,
//         navigation: {
//           nextEl: next,
//           prevEl: prev,
//         },
//         on: {
//           init: function () {
//             updateNavButtons(this, prev, next);
//           },
//           slideChange: function () {
//             updateNavButtons(this, prev, next);
//           },
//           resize: function () {
//             updateNavButtons(this, prev, next);
//           },
//           reachBeginning: function () {
//             prev.style.display = 'none';
//           },
//           reachEnd: function () {
//             next.style.display = 'none';
//           },
//           fromEdge: function () {
//             updateNavButtons(this, prev, next);
//           }
//         }
//       });
//     }
//   });

//   function updateNavButtons(swiper, prevBtn, nextBtn) {
//     if (swiper.isBeginning) {
//       prevBtn.style.display = 'none';
//     } else {
//       prevBtn.style.display = '';
//     }

//     if (swiper.isEnd) {
//       nextBtn.style.display = 'none';
//     } else {
//       nextBtn.style.display = '';
//     }
//   }
// });



document.addEventListener('DOMContentLoaded', function () {
  // Initialize all swipers on page load
  initializeAllSwipers();

  // Create a MutationObserver to watch for added product cards
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        // Check if the node is a product card or contains one
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check regular DOM
          if (node.matches('.product-card-slider') || node.querySelector('.product-card-slider')) {
            initializeSwipersInNode(node);
          }
          
          // Check shadow roots if they exist
          if (node.shadowRoot) {
            if (node.shadowRoot.querySelector('.product-card-slider')) {
              initializeSwipersInNode(node.shadowRoot);
            }
          }
        }
      });
    });
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Function to initialize all swipers in a given node (or document)
  function initializeSwipersInNode(rootNode = document) {
    // Product Card Swipers — multiple instances
    rootNode.querySelectorAll('.product-card-slider').forEach(container => {
      const slider = container.querySelector('.variant-swiper');
      const prev = container.querySelector('.swiper-button-prev');
      const next = container.querySelector('.swiper-button-next');

      if (slider && prev && next && !slider.swiper) {
        const swiper = new Swiper(slider, {
          slidesPerView: 'auto',
          spaceBetween: window.innerWidth <= 768 ? 5 : 8,
          freeMode: true,
          navigation: {
            nextEl: next,
            prevEl: prev,
          },
          on: {
            init: function () {
              updateNavButtons(this, prev, next);
            },
            slideChange: function () {
              updateNavButtons(this, prev, next);
            },
            resize: function () {
              updateNavButtons(this, prev, next);
            },
            reachBeginning: function () {
              prev.style.display = 'none';
            },
            reachEnd: function () {
              next.style.display = 'none';
            },
            fromEdge: function () {
              updateNavButtons(this, prev, next);
            }
          }
        });
      }
    });

    // Product Page Swiper — single instance
    rootNode.querySelectorAll('.product-page .variant-swiper').forEach(slider => {
      const prev = slider.querySelector('.swiper-button-prev');
      const next = slider.querySelector('.swiper-button-next');

      if (slider && prev && next && !slider.swiper) {
        const swiper = new Swiper(slider, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          freeMode: true,
          navigation: {
            nextEl: next,
            prevEl: prev,
          },
          on: {
            init: function () {
              updateNavButtons(this, prev, next);
            },
            slideChange: function () {
              updateNavButtons(this, prev, next);
            },
            resize: function () {
              updateNavButtons(this, prev, next);
            },
            reachBeginning: function () {
              prev.style.display = 'none';
            },
            reachEnd: function () {
              next.style.display = 'none';
            },
            fromEdge: function () {
              updateNavButtons(this, prev, next);
            }
          }
        });
      }
    });
  }

  // Function to initialize all swipers on page load
  function initializeAllSwipers() {
    initializeSwipersInNode(document);
    
    // Also check any existing shadow roots
    document.querySelectorAll('*').forEach(element => {
      if (element.shadowRoot) {
        initializeSwipersInNode(element.shadowRoot);
      }
    });
  }

  function updateNavButtons(swiper, prevBtn, nextBtn) {
    if (swiper.isBeginning) {
      prevBtn.style.display = 'none';
    } else {
      prevBtn.style.display = '';
    }

    if (swiper.isEnd) {
      nextBtn.style.display = 'none';
    } else {
      nextBtn.style.display = '';
    }
  }
});